import { useState } from "react";
import { toast } from "sonner";
import { Button, Dialog, Select, TextField } from "@/components/ui";
import { useCreateWorkspace } from "@/lib/api/queries";
import { useCurrentWorkspace, useWorkspaceStore } from "@/stores/workspace";

/** 목록의 마지막 항목은 워크스페이스가 아니라 "만들기" 입구다. */
const NEW_VALUE = "__new__";

export function WorkspaceSwitcher() {
  const { workspaces, workspace } = useCurrentWorkspace();
  const setWorkspaceId = useWorkspaceStore((s) => s.setWorkspaceId);
  const createWorkspace = useCreateWorkspace();
  // null 이면 다이얼로그가 닫힌 상태다 — 이름 상태와 열림 상태를 하나로 둔다.
  const [newName, setNewName] = useState<string | null>(null);

  function handleCreate() {
    const name = (newName ?? "").trim();
    if (!name || createWorkspace.isPending) return;
    createWorkspace.mutate(name, {
      onSuccess: (created) => {
        setWorkspaceId(created.id);
        setNewName(null);
        toast.success(`${created.name} 워크스페이스를 만들었어요`);
      },
      onError: () => toast.error("만들지 못했어요. 다시 시도해 주세요."),
    });
  }

  return (
    <>
      <Select
        size="medium"
        aria-label="워크스페이스"
        placeholder="워크스페이스 선택"
        value={workspace?.id ?? ""}
        options={[
          ...workspaces.map((w) => ({ value: w.id, label: w.name })),
          { value: NEW_VALUE, label: "+ 새 워크스페이스 만들기" },
        ]}
        onChange={(e) => {
          if (e.target.value === NEW_VALUE) setNewName("");
          else setWorkspaceId(e.target.value);
        }}
      />

      <Dialog
        open={newName !== null}
        title="새 워크스페이스"
        onClose={() => setNewName(null)}
        secondaryAction={
          <Button variant="text" onClick={() => setNewName(null)}>
            취소
          </Button>
        }
        primaryAction={
          <Button onClick={handleCreate} disabled={createWorkspace.isPending}>
            만들기
          </Button>
        }
      >
        <TextField
          label="워크스페이스 이름"
          placeholder="예) 영업관리팀"
          value={newName ?? ""}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleCreate();
          }}
          autoComplete="off"
          enterKeyHint="done"
        />
      </Dialog>
    </>
  );
}

export default WorkspaceSwitcher;
